import { useInitData } from './useInitData'

export function useIsArchivedUsersInBuildingDisplayed() {
  const initData = useInitData()

  return Boolean(initData?.uk?.config?.display_archived_users_in_building)
}
